module.exports = __webpack_public_path__ + "img/img_logoLineC.2c6b3a85.svg";